module.exports = __webpack_public_path__ + "static/media/game-timefont.dd63e296.png";